module.exports = __webpack_public_path__ + "img/step1-4.472189f7.png";